import { render, staticRenderFns } from "./indexx.vue?vue&type=template&id=a6b90f68&"
import script from "./indexx.vue?vue&type=script&lang=js&"
export * from "./indexx.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports